import { Component, h, Host, Prop } from '@stencil/core';
import { AppIconTypes } from './AppIconTypes';

@Component({
  tag: 'app-icon',
  styleUrl: 'app-icon.css',
  shadow: true
})
export class AppIcon {

  @Prop({ reflect: true }) type: AppIconTypes = 'bag';
  @Prop({ reflect: true }) rotate: number = 0;

  render() {
    return <Host>
      <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24" version="1.1">
        <g transform={`rotate(${this.rotate},12,12)`}>
          {this.renderPath(this.type)}
        </g>
      </svg>
    </Host>
  }

  renderPath(type: AppIconTypes) {
    switch (type) {
      case "antix":
        return <g>
          <rect fill="#ddeeff" stroke="none" ry="12" rx="12" y="0" x="0" height="24" width="24" />
          <rect fill="#336699" stroke="none" ry="10" rx="10" y="2" x="2" height="20" width="20" />
          <rect fill="#ffffff" stroke="none" ry="8" rx="8" y="4" x="4" height="16" width="16" />
          <path fill="none" stroke="#333333" stroke-width="2" stroke-linecap="square" stroke-linejoin="round" d="m15,12l-6,0l0,3l6,0l0,-6l-4,0" />
        </g>;

      case "arrow":
        return <path d="M12,2 20,8 14,6 14,22 10,22 10,6 4,8Z" />;

      case "bag":
        return <path d="M7,10 A1,1 0,0,1 17,10 M18.5,10 17.5,18 6.5,18 5.5,10 16,10 A1,1 0,0,0 8,10Z" />

      case "check":
        return <g transform="rotate(45,14,11)">
          <path d="M13,3 17,3 17,21 7,21 7,17 13,17Z" />
        </g>

      case "close":
        return <g transform="rotate(45,12,12)">
          <path d="M10.5,2 13.5,2 13.5,10.5 22,10.5 22,13.5 13.5,13.5 13.5,22 10.5,22 10.5,13.5 2,13.5 2,10.5 10.5,10.5Z" />
        </g>;

      case "grip":
        return <g stroke="none">
          <circle cx="4" cy="4" r="2.5" />
          <circle cx="4" cy="12" r="2.5" />
          <circle cx="4" cy="20" r="2.5" />

          <circle cx="12" cy="4" r="2.5" />
          <circle cx="12" cy="12" r="2.5" />
          <circle cx="12" cy="20" r="2.5" />

          <circle cx="20" cy="4" r="2.5" />
          <circle cx="20" cy="12" r="2.5" />
          <circle cx="20" cy="20" r="2.5" />
        </g>;

      case "heart":
        return <g>
          <path d="M12,22 3,13 A1,1 0 0,1 12,4 A1,1 0 0,1 21,13Z" />
        </g>

      case "minus":
        return <path d="M2,10 22,10 22,14 2,14Z" />

      case "more":
        return <g>
          <circle r="2" cx="12" cy="5" />
          <circle r="2" cx="12" cy="12" />
          <circle r="2" cx="12" cy="19" />
        </g>;

      case "plus":
        return <path d="M10,2 14,2 14,10 22,10 22,14 14,14 14,22 10,22 10,14 2,14 2,10 10,10Z" />

      case "send":
        return <path d="M2,4 22,12 2,20 6,12Z" />

      case "share":
        return <g>
          <path d="M19,4 5,12 19,20" fill="none" />

          <circle r="3" cx="19" cy="4" />
          <circle r="3" cx="5" cy="12" />
          <circle r="3" cx="19" cy="20" />

        </g>;

      case "triangle":
        return <path d="M2,20 12,4 22,20Z" />;

    }
  }
}
